import MicroModal from 'micromodal';
import { load } from '@shopify/theme-sections';
import events from '../utils/events';
import ScrollTo from '../components/scroll-to-reviews';

import '../components/template-product';

load('*');

MicroModal.init({
    awaitCloseAnimation: true,
    awaitOpenAnimation: true,
    disableScroll: true,
    openClass: 'modal--active',
});

const selectors = {
    yotpoToggle: '[data-yotpo-toggle]',
    scrollTarget: '[data-yotpo-reviews]'
};

new ScrollTo(
    document.querySelector('.product-details'),
    selectors.scrollTarget,
    selectors.yotpoToggle,
    events.accordionOpen
);